import React from 'react';
import { Spin, Empty, Button, Typography, Tooltip, Popover } from 'antd';
import { strategyItem } from '../index';
import '../pandora-cards/index.less';

const { Paragraph } = Typography;

enum PromotionIdType {
  // 总价促销
  promotion = 17,
  // 优惠券
  coupon = 32,
}

export default function SalePlaySelectCards({
  planCode,
  toSalePlaySelect,
  toSalePlaySelectAndPromotionId,
  list,
}: {
  planCode: string;
  toSalePlaySelect: any;
  toSalePlaySelectAndPromotionId: any;
  list: strategyItem[];
}) {
  const renderBtn = (item: strategyItem) => {
    if (item?.materialType === '5') {
      return (
        <Button type="primary" ghost onClick={() => toSalePlaySelect(Number(item.poolType), item.materialType)}>
          去选店
        </Button>
      );
    }
    return PromotionIdType.coupon === Number(item.poolType) || PromotionIdType.promotion === Number(item.poolType) ? (
      <Button
        type="primary"
        ghost
        onClick={() => toSalePlaySelectAndPromotionId({ poolType: item.poolType, planCode })}
      >
        去选品
      </Button>
    ) : (
      <Button type="primary" ghost onClick={() => toSalePlaySelect(Number(item.poolType), item.materialType)}>
        去选品
      </Button>
    );
  };

  return (
    // @ts-ignore
    <Spin spinning={list.length === 0}>
      {list && list?.length ? (
        <div className="sale-play-select-cards-list">
          {list.map((item: any, index) => {
            return (
              <div key={index} className="sale-play-select-card" style={{ background: item.background }}>
                <div className="card-content">
                  <div className="content-desc">
                    <div className="desc-title">{item.name}</div>
                    <Paragraph className="desc-text" ellipsis={{ rows: 2 }}>
                      <Tooltip
                        title={item.description}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                      >
                        {item.description}
                      </Tooltip>
                    </Paragraph>
                    <div className="scene-title">适用场景：{item.scene}</div>
                  </div>
                  <Popover
                    content={<img src={item.picUrl} className="cards-list-popover-img" />}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                  >
                    <img src={item.picUrl} className="cards-list-img" />
                  </Popover>
                </div>
                <div className="card-footer">{renderBtn(item)}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Spin>
  );
}
